<template>
    <div class="foot-wrapper">
        <a-descriptions title="" layout="vertical">
            <a-descriptions-item label="联系人">高经理</a-descriptions-item>
            <a-descriptions-item label="联系电话"><a href="#contact"></a>{{siteInfo?.contactPhone}}</a-descriptions-item>
            <a-descriptions-item label="地址" :span="2">{{siteInfo?.address}}</a-descriptions-item>
            <a-descriptions-item label="微信（长按添加）">
                <a-image :preview="false" width="150px"
                         src="wechat.png"
                />
            </a-descriptions-item>
            <a-descriptions-item label="备案号"> {{siteInfo?.icp}}
                <br/>
                <a-image :preview="false" width="15px"
                         src="batb.png"
                />
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=46020002000200" rel="noreferrer" target="_blank"> 琼公网安备46020002000200号</a>
            </a-descriptions-item>
            <a-descriptions-item label="声明">{{siteInfo?.description}}</a-descriptions-item>
        </a-descriptions>
    </div>
</template>

<script setup>
    import {onMounted,ref} from 'vue';
    import {API_siteInfoById} from '../api/api.js'

    const siteInfo = ref({});

    onMounted(() => {
        getSiteInfo();
    });

    function getSiteInfo() {
        API_siteInfoById().then(res => {
            if (res.success) {
                siteInfo.value = res.result
            }

        });
    }
</script>

<style scoped>
    .foot-wrapper {
        font-weight: bolder;
        padding: 60px;
        width: 100%;
        background-color: snow;
        text-align: center;
    }
</style>